import PhoneNumberMask from './phoneNumberMask';

export default PhoneNumberMask;
